import { jsx as l, jsxs as i } from "react/jsx-runtime";
import { ColorPicker as g, Tooltip as v, NeutralButton as x, NeutralTypeEnum as y, PrimaryButton as A } from "@systemeio/ui";
import { useEditorState as E } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as I } from "react";
import { twMerge as p } from "tailwind-merge";
import { DEFAULT_BG_COLOR as w, getToolbarIconClassName as b, TOOLBAR_BUTTON_CLASSNAMES as C, getToolbarCaptionClassName as L, TOOLTIP_STYLES as O } from "../../constants/default-styles.mjs";
import h from "../../icons/highlighter-icon.mjs";
import { useTranslation as _ } from "../../i18n.mjs";
import { FocusTrapFeatures as f, FocusTrap as F } from "@headlessui/react";
import { normalizeToHex as P } from "@systemeio/util";
import { isImageSelected as S } from "../image-extension/utils/is-image-selected.mjs";
const Q = (e, T) => {
  const { t: s } = _(), { shouldHideTooltip: m, showAlpha: t = !0 } = T ?? {}, r = E({
    editor: e,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      backgroundColor: o == null ? void 0 : o.getAttributes("textStyle").backgroundColor,
      isImageSelected: S(o)
    })
  }), u = r == null ? void 0 : r.backgroundColor, n = u ? P(u) : w, a = !(r != null && r.isEditable) || !!(r != null && r.isImageSelected), c = !!u;
  return I(() => {
    const o = (B) => {
      if (!e) return null;
      e.chain().setBackgroundColor(B).run();
    }, k = () => {
      if (!e) return null;
      e.chain().focus().setBackgroundColor(n).run();
    }, N = () => {
      if (!e) return null;
      e.chain().focus().unsetBackgroundColor().run();
    }, d = () => /* @__PURE__ */ l(F, { features: f.None, children: /* @__PURE__ */ i("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ l(
        x,
        {
          className: "w-full",
          neutralType: y.danger,
          disabled: !c,
          onClick: N,
          children: s("global.clear")
        }
      ),
      /* @__PURE__ */ l(A, { className: "w-full", onClick: k, children: s("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ l(
        g,
        {
          disabled: a,
          additionalPopoverChildren: d,
          color: n,
          onChange: o,
          showAlpha: t,
          children: () => /* @__PURE__ */ l(
            v,
            {
              disabled: m || a,
              label: s("background_color"),
              ...O,
              children: /* @__PURE__ */ i(
                "div",
                {
                  className: p(
                    C,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ l(h, { className: b(a) }),
                    c && /* @__PURE__ */ l(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: n }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ l(
        g,
        {
          disabled: a,
          focusTrapFeatures: f.FocusLock,
          additionalPopoverChildren: d,
          color: n,
          onChange: o,
          showAlpha: t,
          children: () => /* @__PURE__ */ i(
            "div",
            {
              className: p(
                C,
                "gap-1.5",
                "relative",
                "flex gap-1",
                L(a)
              ),
              children: [
                /* @__PURE__ */ l(h, { className: b(a) }),
                s("background_color"),
                c && /* @__PURE__ */ l(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: n }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [n, e, c, a, m, t, s]);
};
export {
  Q as useTextBackgroundColorExtensionToolbar
};
